import React from 'react'
import './DownloadLotti.css'
import Lottie from 'react-lottie';
import * as animationData from './Download.json';
const DownloadLotti= () => {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };
    return (
        <>
            <div className='download-lottey mx-auto'>
                <Lottie className=" lotties"
                    options={defaultOptions}
                />
            </div>
        </>
    )
}

export default DownloadLotti